// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2T8K-","inner":"Footer_inner__1qBiO","nextIcon":"Footer_nextIcon__F9XNq","innerLeft":"Footer_innerLeft__SoZPf"};